import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const usersWithoutComputersConstants = {
    UWC_LOADED: 'UWC_LOADED',
    UWC_CLEARED: 'UWC_CLEARED'
};

export const UWCFulfilledConstants = getActionTypesResult(usersWithoutComputersConstants, '_FULFILLED');
export const UWCPendingConstants = getActionTypesResult(usersWithoutComputersConstants, '_PENDING');
export const UWCRejectedConstants = getActionTypesResult(usersWithoutComputersConstants, '_REJECTED');

export const fetchUsersWithoutComputers = createAsyncAction(usersWithoutComputersConstants.UWC_LOADED, query =>
    api.get('user/equipment/empty', { params: query, paramsSerializer: { indexes: null } }).then(res => res.data)
);

export const clearUsersWithoutDevices = () => ({ type: usersWithoutComputersConstants.UWC_CLEARED });
